import cx from 'classnames'
import React from 'react'

import { Outline } from '@cinch/oxd-components/button/src'
import Geocode from '@cinch/oxd-components/geocode/src'
import Text, { TextStyles } from '@cinch/oxd-components/text/src'

import staticMapSrc from './static-map'

import { GeoCodeParams } from '@cinch/oxd-components/geocode/src/geocode.component'

import * as styles from './location-widget.module.css'

const LocationWidget: React.FC<
  GeoCodeParams & {
    onSubmit: (input: GeoCodeParams) => void
    isFilter?: boolean
    children?: React.ReactNode
  }
> = ({ location, latitude, longitude, onSubmit, isFilter, children = null }) => {
  const hasData = Boolean(location && latitude && longitude)
  const [isOpen, setOpen] = React.useState(!hasData)

  React.useEffect(() => {
    const hasUpdatedData = Boolean(location && latitude && longitude)
    if (!hasUpdatedData !== isOpen) {
      setOpen(!hasUpdatedData)
    }
  }, [location, latitude, longitude])

  const onChange = (locationUpdate: GeoCodeParams) => {
    setOpen(false)

    onSubmit(locationUpdate)
  }

  const onCancelGeocode = () => {
    setOpen(false)
  }

  return (
    <div className={cx(styles.block, { [styles.isOpen]: isOpen, [styles.filter]: isFilter })}>
      {isOpen ? (
        <>
          <Geocode onChange={onChange} onCancel={hasData ? onCancelGeocode : undefined} />
          {children}
        </>
      ) : (
        <>
          {isFilter && hasData && (
            <Text element="div" type={TextStyles.caption}>
              {location}
            </Text>
          )}
          <Outline onClick={() => setOpen(true)} size={'mini'}>
            Change
          </Outline>
          {children}
          {!!hasData && !isFilter && (
            <div className={styles.block}>
              <img
                className={styles.map}
                alt={location}
                src={staticMapSrc({ center: `${latitude},${longitude}`, size: '650x430' })}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default LocationWidget
